// https://app.growthbook.io/features/pen-7565_v1
export const PROMO_BANNER_200_CLASSES_FLAG_NAME = 'pen-7565_v1'
